import {reportBizImpression, reportBizOnlyImpression, reportBizPvUrls} from "./mBizReport";

export const presetOnlyImpression = {
    action: reportBizOnlyImpression
}

export const presetPvUrls = {
    action: reportBizPvUrls
}

// /*export const impression = {
//     value: () => {
//         // TODO: 这里需要提供当前正在播放的 campaign，而不是固定传第一个 campaign，
//         //  这种当前 campaign 不确定的场景，不能写死，可以考虑做成 function
//         return App.initData.campaignList[0]
//     },
//     action: reportBizImpression
// }*/

export const impression = ({currentCampaign}) => {
    return {
        value: () => {
            if (typeof currentCampaign !== 'undefined') {
                return currentCampaign
            } else {
                console.error('传入的 campaign 不合法', currentCampaign)
                return {}
            }
        },
        action: reportBizImpression
    }
}